import React, { useState } from 'react';
import ImgModal from "./ImgModal";

function CardItem(props) {
  const [hidden, setHidden] = useState(true);

  return (
    <>
      <ImgModal source={props.src} hidden={hidden} onChange={setHidden}></ImgModal>
      <li className='cards__item' onClick={() => props.onClick(props.src, props.text)}>
        <div className='cards__item__link'>
          <div className='cards__item__pic-wrap'>
            <img
              className='cards__item__img'
              alt='Arthia Projetos'
              src={props.src}
            />
          </div>
          <div className='cards__item__info'>
            <h5 className='cards__item__text'>{props.text}</h5>
          </div>
        </div>
      </li>
    </>
  );
}

export default CardItem;
